import { OverrideCandidateSuspensionComponent } from "./override-candidate-suspension.component";
export const OverrideCandidateSuspensionModule = angular
    .module('overrideCandidateSuspension', [])
    .component(OverrideCandidateSuspensionComponent.selector, OverrideCandidateSuspensionComponent.component)
    .name;
//# sourceMappingURL=override-candidate-suspension.module.js.map